import type { BootstrapToast } from "./types/bootstrap.js";
// Questo file replica ./modals.ts ma focalizza sui toast bootstrap
interface ToastOptions {
    title?: string;
    type?: 'info' | 'success' | 'warning' | 'danger';
    message?: string;
    icon?: string;
    iconClass?: string;
    showCloseButton?: boolean;
    animation?: boolean;
    autohide?: boolean;
    delay?: number;
    timeStamp?: boolean;
}
let _container: HTMLElement|null = null ;
const getToastContainer = (): HTMLElement => {
    if (_container) {
        return _container;
    }
    _container = document.querySelector('.toast-container');
    if (!_container) {
        _container = document.createElement('div');
        _container.classList.add('toast-container', 'position-fixed', 'bottom-0', 'start-0', 'p-3');
        _container.style.zIndex = '1051'; // Bootstrap default z-index for toasts
        document.body.appendChild(_container);
    }
    return _container;
}

const templateRender = (options: ToastOptions) => {
    // ripresa delle opzioni del toast
    const {
        title = 'Notification',
        type = 'info',
        message = '',
        icon = 'bi-info-circle-fill',
        iconClass = '',
        showCloseButton = true,
        animation = true,
        autohide = true,
        delay = 5000,
        timeStamp = false
    } = options;
    const header = `<div class="toast-header text-${type}">
                ${iconClass ?
            `<i class="bi ${iconClass} me-2"></i>`
            : ``}  
                <strong class="me-auto">${title}</strong>
                ${timeStamp ?
            `<small class="text-muted">${new Date().toLocaleTimeString()}</small>`
            : ''}
                ${showCloseButton ?
            `<button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>`
            : ''}
            </div>`
    return `<div  class="toast" role="alert" 
            data-bs-animation="${animation?'true':'false'}" 
            data-bs-autohide="${autohide?'true':'false'}"
            data-bs-delay="${delay}"
            aria-live="assertive" aria-atomic="true">
            ${header}
            <div class="toast-body">
                ${message}
            </div>
        </div>`;
}
/**
 * Generica funzione per mostrare un toast
 * @param options Opzioni per il toast
 */
export const showToast = (options: ToastOptions): void => {
        const {
        autohide = true,
        delay = 5000
    } = options;
    const container = getToastContainer();
    const toastElement = document.createElement('div');
    toastElement.innerHTML = templateRender(options);
    const actualToastElement = toastElement.firstElementChild as HTMLElement;
    
    container.appendChild(actualToastElement);
    
    const toast: BootstrapToast = new window.bootstrap.Toast(actualToastElement, {
        autohide,
        delay
    });
    toast.show();
    // Rimuove il toast dopo la chiusura
    actualToastElement.addEventListener('hidden.bs.toast', () => {
        actualToastElement.remove();
    });

}
export const toastError =  (message: string, title="Errore", autohide=true, options: Partial<ToastOptions> = {}): void => {
    showToast({
        ...options,
        title,
        type: 'danger',
        message,
        icon: 'bi-exclamation-triangle-fill',
        iconClass: 'text-danger',
        autohide
    });
}
export const toastSuccess =  (message: string, title="Successo", autohide=true, options: Partial<ToastOptions> = {}): void => {
    showToast({
        ...options,
        title,
        type: 'success',
        message,
        icon: 'bi-check-circle-fill',
        iconClass: 'text-success',
        autohide
    });
}
export const toastInfo =  (message: string, title="Informazione", autohide=true, options: Partial<ToastOptions> = {}): void => {
    showToast({
        ...options,
        title,
        type: 'info',
        message,
        icon: 'bi-info-circle-fill',
        iconClass: 'text-info',
        autohide
    });
}
export const toastWarning =  (message: string, title="Attenzione", autohide=true, options: Partial<ToastOptions> = {}): void => {
    showToast({
        ...options,
        title,
        type: 'warning',
        message,
        icon: 'bi-exclamation-circle-fill',
        iconClass: 'text-warning',
        autohide
    });
}   